<form #userForm="ngForm" (ngSubmit)="onSaveUser()">
  <div class="row">
    <h3 class="col-md-12 section-title">{{'Account Information' | translate}}</h3>
  </div>
  <div *ngIf="usernameExists" class="form-group row">
    <label class="col-sm-12 col-form-label">
      <strong>{{'Username:' | translate}}</strong> {{userDetails.username}}</label>
  </div>
  <div class="row">
    <div class="col-md-12 change-password-container" *ngIf="!registerAction">
      <button type="button" class="btn btn-outline-info btn-sm" (click)="showModal()">
        {{'Change Password' | translate}}
      </button>
    </div>
  </div>

  <div class="row">
    <h3 class="col-md-12 section-title">{{'Personal Information' | translate}}</h3>
    <div class="form-group col-md-3" *ngIf="registerAction">
      <label for="password">Primary Diagnosis</label>
      <select name="diagnostics" class="form-control" [(ngModel)]="userDetails.diagnosis" required #diagnostics="ngModel">
        <option *ngFor="let d of diagnosticsArray" [ngValue]="d.diagnostic">{{d.description}}</option>
      </select>
      <small [hidden]="diagnostics.valid || diagnostics.pristine" class="incorrect-field">
        Diagnosis is required
      </small>
    </div>

  </div>
  <div class="row">
    <div class="form-group col-md-3" *ngIf = "!isCustomFieldValid('firstName', CUSTOM_FIELD_HIDE)">
      <label for="firstName">{{'First Name' | translate}}</label>
      <input [(ngModel)]="userDetails.firstName" name="userDetails.firstName" type="text" class="form-control" id="firstName" [required]="isCustomFieldValid('firstName', CUSTOM_FIELD_REQUIRED)"
        #firstName="ngModel" [disabled]="isCustomFieldValid('firstName', CUSTOM_FIELD_DISABLE)">
      <small [hidden]="firstName.valid || firstName.pristine" class="incorrect-field">
        {{'First Name is required' | translate}}
      </small>
    </div>
    <div class="form-group col-md-3" *ngIf = "!isCustomFieldValid('middleName', CUSTOM_FIELD_HIDE)">
      <label for="middleName">{{'Middle Name' | translate}}</label>
      <input [(ngModel)]="userDetails.middleName" name="userDetails.middleName" type="text" class="form-control" id="middleName" [required]="isCustomFieldValid('middleName', CUSTOM_FIELD_REQUIRED)"
      [disabled]="isCustomFieldValid('middleName', CUSTOM_FIELD_DISABLE)">
    </div>
    <div class="form-group col-md-3" *ngIf = "!isCustomFieldValid('lastName', CUSTOM_FIELD_HIDE)">
      <label for="lastName">{{'Last Name' | translate}}</label>
      <input [(ngModel)]="userDetails.lastName" name="userDetails.lastName" type="text" class="form-control" id="lastName" [required]="isCustomFieldValid('lastName', CUSTOM_FIELD_REQUIRED)"
        #lastName="ngModel" [disabled]="isCustomFieldValid('lastName', CUSTOM_FIELD_DISABLE)">
      <small [hidden]="lastName.valid || lastName.pristine" class="incorrect-field">
        {{'Last Name is required' | translate}}
      </small>
    </div>
  </div>
  <div class="row">
      <div class="form-group col-md-3" *ngIf = "!isCustomFieldValid('language', CUSTOM_FIELD_HIDE)">
          <label for="language">{{'Language' | translate}}</label>
          <select id="language" name="idLanguage" class="form-control" [(ngModel)]="userDetails.language.idLanguage"
                  [required]="isCustomFieldValid('language', CUSTOM_FIELD_REQUIRED)" [disabled]="isCustomFieldValid('language', CUSTOM_FIELD_DISABLE)">
            <option *ngFor="let l of languages" [ngValue]="l.idLanguage">{{l.name}}</option>
          </select>
        </div>
    <h3 class="col-md-12 section-title" *ngIf = "!isCustomFieldValid('phoneCell', CUSTOM_FIELD_HIDE)">{{'Contact Information' | translate}}</h3>
    <div class="form-group col-md-3" *ngIf = "!isCustomFieldValid('phoneCell', CUSTOM_FIELD_HIDE)">
      <label for="phoneCell">
        {{'Primary Phone Number' | translate}}
      </label>
      <input [(ngModel)]="userDetails.phoneCell" name="userDetails.phoneCell" type="text" class="form-control" id="phoneCell" [required]="isCustomFieldValid('phoneCell', CUSTOM_FIELD_REQUIRED)"
      #phoneCell="ngModel" [disabled]="isCustomFieldValid('phoneCell', CUSTOM_FIELD_DISABLE)">
      <small [hidden]="phoneCell.valid || phoneCell.pristine" class="incorrect-field">
        {{'Primary phone number is required' | translate}}
      </small>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-3">
      <button type="submit" [disabled]="!userForm.form.valid" class="btn btn-block btn-success save-button" (click)="refresh()">{{'Save' | translate}}</button>
    </div>
  </div>
</form>
